import Icon from "react-icons-kit";
import {navigateTo} from "gatsby-link";
import {music_headphones} from "react-icons-kit/linea/music_headphones";
import React, {Component} from "react";
import SpotifyWebApi from "spotify-web-api-js";

import styles from "./nowplaying.module.css";

class NowPlaying extends Component {
  constructor(props) {
    super(props);
    this._base64auth = Buffer.from(`${process.env.SPOTIFY_CLIENT_ID}:${process.env.SPOTIFY_SECRET}`).toString('base64');
    this.spotifyApi = new SpotifyWebApi();
  }

  componentWillMount() {
    this.state = {
      currentSong: "",
      validAuth: false,
    };
  }

  componentDidMount() {
    // this._getAuthCode();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.refreshInterval);
  }

  _getAuthApi = () => {
    return fetch(`${process.env.AUTH_URI}/api/auth`);
  }

  _getAuthCode = () => {
    if (this.state.validAuth === false) {

    }
    if (window.location.search === "") {
      this._getAuthApi()
      .then(response => response.json())
      .then(response => {
        if (!response.auth) {
          window.location = "https://accounts.spotify.com/en/authorize?client_id=f420563aee4d456d8cc5281527fe2de9&response_type=code&redirect_uri=http:%2F%2Flocalhost:8000%2F&scope=user-read-currently-playing%20user-read-recently-played";
        } else {
          this._authCode = response.auth;
          this._setupAuth();
        }
      });
    } else {
      const hashParams = new URLSearchParams(window.location.search);
      const code = hashParams.get("code");
      this._authCode = code;

      fetch(`${process.env.AUTH_URI}/api/auth`, {
        headers: new Headers({ "Content-Type": "application/json" }),
        method: "POST",
        body: JSON.stringify({ authCode: code })
      }).then(resp => {
        window.history.replaceState({}, "", "/");
        this._setupAuth();
      });
    }
  }

  _setupAuth = () => {
    this._headers = new Headers();
    this._headers.append("Access-Control-Allow-Origin", "*");
    this._headers.append("Access-Control-Allow-Methods", "POST");
    this._headers.append("Access-Control-Allow-Headers", "Origin, Content-Type, Authorization");
    this._headers.append("Authorization", `Basic ${this._base64auth}`);
    this._headers.append("Accept", "application/json");
    this._headers.append("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");

    const authData = new URLSearchParams();
    authData.append("grant_type", "authorization_code");
    authData.append("code", this._authCode);
    authData.append("redirect_uri", process.env.REDIRECT_URI);

    fetch("https://accounts.spotify.com/api/token", {
      method: "POST",
      body: authData,
      headers: this._headers
    }).then(resp => resp.json()).then(resp => {
      if (resp.error_description && (resp.error_description === "Invalid authorization code" || resp.error_description === "Authorization code expired")) {
        this._authCode = null;
        fetch(`${process.env.AUTH_URI}/api/auth`, {
          headers: new Headers({ "Content-Type": "application/json" }),
          method: "POST",
          body: JSON.stringify({ authCode: null })
        }).then(resp => {
          window.history.replaceState({}, "/");
          this._getAuthCode();
        });
      } else {
        this.spotifyApi.setAccessToken(resp.access_token);
        this._getNowPlaying();
        this.interval = setInterval(this._getNowPlaying, 15000);
      }
    });
  }

  _refreshAccessToken = () => {
    const formData = new FormData();
    formData.append("grant_type", "refresh_token");
    formData.append("refresh_token", this._refreshToken);

    fetch("https://accounts.spotify.com/api/token", {
      method: "POST",
      body: formData,
      headers: this._headers
    }).then(resp => {
      this.spotifyApi.setAccessToken(resp.access_token);
    });
  }

  _getNowPlaying = () => {
    if (!this.spotifyApi.getAccessToken())
      return;
    this.spotifyApi.getMyCurrentPlayingTrack().then(response => {
      if (!response)
        return;
      if (response.error) {
        this._getAuthCode();
        return;
      }
      this.setState({currentSong: `${response.item.name} - ${response.item.artists[0].name}`});
    });
  }

  render() {
    return (<div className={styles.nowPlaying}>
      <a href="https://open.spotify.com/user/124416386?si=0ev4pKdDT02UPzH1eJujgg"><Icon icon={music_headphones} size={24}/> <div className={styles.song}>{this.state.currentSong}</div></a>
    </div>);
  }
}

export default NowPlaying;



// WEBPACK FOOTER //
// ./src/components/nowplaying.js